module.exports = __webpack_public_path__ + "fb88735730905f6a365d0c391d3101fe.png";